import {
  WIX_BLOG,
  WIX_EVENTS,
  WIX_FILE_SHARE,
  WIX_FORUM,
  WIX_GROUPS,
} from '@wix/app-definition-ids';

const WIX_MEMBERS_FOLLOWERS = '14ebe801-d78a-daa9-c9e5-0286a891e46f';
const WIX_MEMBERS_ABOUT = '14dbef06-cc42-5583-32a7-3abd44da4908';
const WIX_SHARED_GALLERY = '476dc2dd-e16e-43b0-a0aa-1a486c78fbe2';

export const SOCIAL_APPS = [
  WIX_BLOG,
  WIX_FORUM,
  WIX_GROUPS,
  WIX_EVENTS,
  WIX_MEMBERS_FOLLOWERS,
  WIX_MEMBERS_ABOUT,
  WIX_FILE_SHARE,
  WIX_SHARED_GALLERY,
];

export const PROFILE_PAGE_BOB_APP_DEF_ID =
  'b976560c-3122-4351-878f-453f337b7245';

export const NOTIFICATIONS_APP_ID = '14f25924-5664-31b2-9568-f9c5ed98c9b1';

export const MEMBER_TPA_PAGE_ID = 'member_page';
export const MEMBER_SETTINGS_TPA_PAGE_ID = 'member_settings_page';
